<template>
    <button class="datatable-button">
        <span v-if="title">{{ title }}</span>
        <span v-if="badge" class="datatable-button-badge">{{ badge }}</span>
        <i v-if="icon" :class="[icon]"></i>
    </button>
</template>

<script>
export default {
    name: "DatatableButtonComponent",
    props: {
        title: {
            type: String,
            default() {
                return '';
            }
        },
        icon: {
            type: String,
            default() {
                return null;
            }
        },
        badge: {
            type: String,
            default() {
                return null;
            }
        }
    },
}
</script>

<style scoped>
.datatable-button {
    border: none;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    margin: 0;

    display: flex;
    background: #f5f5f5;
    padding: 7px 10px;
    font-weight: 500;
    column-gap: 10px;
    transition: background 0.3s;
    justify-content: space-between;
    border-radius: 0.125rem;
}

.datatable-button.without-background {
    background: none;
}

.datatable-button:hover {
    background: #ebeaea;
}

.datatable-button i{
    position: unset;
    line-height: 20px;
}

.datatable-button i.icon-cross2,
.datatable-button i.icon-plus3,
.datatable-button i.icon-star-full2
{
    font-size: 10px;
}

.datatable-button-badge{
    background: #3f51b5;
    color: white;
    line-height: 16px;
    height: 16px;
    padding: 0 5px;
    margin: 2px 0;
    font-size: 10px;
    border-radius: 2px;
    display: inline-block;
}
</style>
